import { authenticatedRequest } from '@/services';
import { HttpMethod } from '@/lib/enums';
import type { TaxonomyTreeNode } from '@/app/audience-builder/services/fetch-intent-topics';

export interface TechnographicTree {
  version: string;
  /** Category → (Group →) Type → Products, as deep as the taxonomy goes. Products carry a vendor. */
  tree: TaxonomyTreeNode[];
}

/**
 * The whole technology tree, products included (~25 MB on staging). The browse modal, the chips
 * and a reopened audience all read names and levels from it, so it is fetched once and cached.
 */
export const fetchTechnographicTree = async (): Promise<TechnographicTree> =>
  (await authenticatedRequest({
    resource: 'audience-explorer/technographics/tree',
    method: HttpMethod.GET,
  })) as TechnographicTree;
